
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coach-community",
      function () {
        return require("private-next-pages/coach-community.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coach-community"])
      });
    }
  